import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AccessDeniedComponent } from '../errors/components/access-denied/access-denied.component'
import { NotFoundErrorComponent } from '../errors/components/not-found-error/not-found-error.component'
import { ArpioRootComponent } from './components/arpio-root/arpio-root.component'
import { TestPageComponent } from './components/test-page/test-page.component'
import { ArpioAlertComponent } from './arpio-alert/components/arp-alert/arpio-alert.component'

const routes: Routes = [
  { path: '', component: ArpioRootComponent },
  { path: 'access-denied', component: AccessDeniedComponent },
  // A destination for pages that decide mid-flight that they don't exist for this account.
  // The root '**' wildcard can't serve that: ':accountId' matches any single segment first,
  // and this module is registered ahead of AccountRoutingModule so the literal wins.
  { path: 'not-found', component: NotFoundErrorComponent },
  { path: 'test_page', component: TestPageComponent },
  // The underscore is easy to mistype. Like the routes above, this has to live here
  // rather than in AccountRoutingModule, whose ':accountId' would match it first.
  { path: 'test-page', redirectTo: 'test_page', pathMatch: 'full' },
  { path: 'alerts', component: ArpioAlertComponent },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArpioRoutingModule {}
